var _style, _g, _defs, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5F606D;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.7,20.3v-10h3.1c0.9,0,1.7,0.2,2.3,0.6s1.2,1,1.6,1.7s0.6,1.6,0.6,2.5v0.5c0,0.9-0.2,1.7-0.6,2.5 c-0.4,0.7-0.9,1.3-1.6,1.7s-1.5,0.6-2.3,0.6H43.7z M45.8,12v6.6h1c0.8,0,1.4-0.3,1.8-0.8c0.4-0.5,0.6-1.3,0.6-2.2v-0.5 c0-1-0.2-1.8-0.6-2.3s-1-0.8-1.8-0.8H45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.3,18.3h-3.6L54,20.3h-2.2l3.7-10h1.9l3.7,10H59L58.3,18.3z M55.3,16.6h2.5l-1.3-3.7L55.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.8,16.7h-1.6v3.6h-2.1v-10h3.7c1.2,0,2.1,0.3,2.7,0.8s1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7 c-0.3,0.5-0.7,0.8-1.3,1.1l2.2,4.1v0.1h-2.2L65.8,16.7z M64.2,15h1.7c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1 c-0.3-0.3-0.7-0.4-1.2-0.4h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,16.3l-1.1,1.1v2.8H71v-10h2.1v4.5l0.9-1.2l2.5-3.3h2.5l-3.5,4.4l3.6,5.5h-2.4L74.2,16.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.4,21.2c0.3,0,0.7,0.1,1.1,0.1c3.9,0,7-2.7,7-6.1c0-3.4-3.2-6.1-7-6.1c-0.3,0-0.5,0-0.8,0 c1.9,1.3,3.2,3.5,3.2,6C20.9,17.6,19.5,19.9,17.4,21.2z M19.4,22.6c4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6s-7.6,3.4-7.6,7.6 S15.1,22.6,19.4,22.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.9ce63c1e4d77e6055a50764940c57ed2.svg";
export { ForwardRef as ReactComponent };